import type { Module } from './ImageStack';
import loadModule from './ImageStack';
import moduleUrl from './ImageStack.wasm?url';

const _instance: Record<string, unknown> = {};

export async function loadWasmModule(): Promise<void> {
  const instance = await loadModule({
    locateFile: (url: string): string => {
      if (url == 'ImageStack.wasm') {
        return moduleUrl;
      }
      throw new Error('Unexpected url');
    }
  });
  _instance._module = instance;
  Object.assign(_instance, instance);
}

export default _instance as unknown as Module;

export * from './ImageStack';
